import React, { useEffect, useState } from "react";
import Spinner from "../../../spinner";
import { Button, Col, Table, Row, notification } from "antd";
import { tableHelper } from "../../../../helpers";
import ModalListShipCompanies from "../../../modals/list-ship-companies";
import ModalEditLegalEntityDocs from '../../../modals/edit-legal-entity-docs';
import { useFetchNotification } from "../../../../hooks/use-fetch-notification";
import NotificationMessage from "../../../modals/notification-message";
import ModalCreateNewLegalEntity from "../../../modals/create-legal-entity";
import ModalLegalEntityAgreement from "../../../modals/legal-entity-agreement";
import ModalEditLegalEntityNew from "../../../modals/edit-legal-entity-new";
import ModalEditLegalEntityTax from "../../../modals/edit-legal-entity-tax";
import ModalEditLegalEntityGosLog from "../../../modals/edit-legal-entity-gos-log";
import {companyService, userServices} from "../../../../services";
import {COMPANY_DIRECTOR_PERMISSION, CONSIGNOR_DIRECTOR_PERMISSION} from "../../../../helpers/user_permission.helper";
import {Redirect } from "react-router-dom";
import i18n from '../../../../i18n';

export default function LegalEntities() {
  const [loading, setLoading] = useState(false);
  const [isNeedUpdateEntities, setIsNeedUpdateEntities] = useState(false);
  const [stopListUpdate, setStopListUpdate] = useState(false);
    const [isAgree, setIsAgree] = useState(0);

  const [showModalCreateEntity, setShowModalCreateEntity] = useState(false);
  const [showModalCreateEntityTest, setShowModalCreateEntityTest] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);

  const [showModalShipCompanies, setShowModalShipCompanies] = useState(false);
  const [currentEntityId, setCurrentEntityId] = useState(null);
  const [currentConsignorId, setCurrentConsignorId] = useState(null);
  const [currentOrgFormName, setCurrentOrgFormId] = useState(null);
  const [currentEntityName, setCurrentEntityName] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [entitiesData, setEntitiesData] = useState(null);

  const [isShowEditEntity, setShowEditEntity] = useState(false);
  const [isShowEditEntityDocs, setShowEditEntityDocs] = useState(false);
  const [isShowEditEntityTaxs, setShowEditEntityTaxs] = useState(false);
  const [isShowEditEntityGosLog, setShowEditEntityGosLog] = useState(false);

  const [{ notifications }] = useFetchNotification(true);

  const user = userServices.getUser();

  let bigButtonStyle = { width: '190px', height: '40px', background: '#1CAA53', position: 'static', borderRadius: '10px', float: 'right', borderColor: "#1CAA53" };

  useEffect(() => {
    if (loading === false && stopListUpdate !== true) {
      setLoading(true);
      setIsNeedUpdateEntities(true);
    }
  }, [isNeedUpdateEntities, stopListUpdate]);

  useEffect(() => {
      if (isNeedUpdateEntities) {
          companyService
              .getEntitiesList()
              .then((response) => {
                  let reindexedTableData = [];
                  response.forEach((item) => {
                      reindexedTableData.push({
                          name: item.Name,
                          orgForm: item.OrgForm,
                          orgFormId: item.OrgFormId,
                          id: item.Id,
                          consignorId: item.ConsignorId || item.consignorId || (item.Consignor ? item.Consignor.Id : null) || null,
                          confirmation: item.VitalAgreed ? i18n.t('main.confirm.answer.yes') : i18n.t('main.confirm.answer.no'),
                          permissions: item.Permissions,
                          tax: (item.Tax ? item.Tax.fullTitle : ''),
                          countryId: item.CountryId,
                      });

                       if(item.IsNeedSetTax) {
                         setCurrentEntityId(item.Id);
                         setCurrentEntityName(item.Name);
                         setShowEditEntityTaxs(true);
                       }
                       
                       if(item.Permissions.IsNeedSetGosLog) {
                         setCurrentEntityId(item.Id);
                         setCurrentEntityName(item.Name);
                         setShowEditEntityGosLog(true);
                       }
                  });

                  setEntitiesData(reindexedTableData);
                  setIsNeedUpdateEntities(false);
                  setLoading(false);
              })
              .catch((errorMsg) => {
                  setIsNeedUpdateEntities(false);
                  setErrorMsg(errorMsg);
                  setLoading(false);
              });
      }
  }, [isNeedUpdateEntities]);

  const handleEditLegalEntity = entityId => {
    setCurrentEntityId(entityId);
    setShowEditEntity(true);
  };

  const handleDeleteLegalEntity = entityId => {
    setLoading(true);

    companyService
      .deleteLegalEntity(entityId)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.deleteLegalEntity'),
          description: response.message,
        });

        setLoading(false);
        setIsNeedUpdateEntities(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.deleteLegalEntity'),
          description: error,
        });

        setLoading(false);
      });
  };

  const handleEditLegalEntityDocs = entityId => {
    setCurrentEntityId(entityId);
    const entityRow = entitiesData.find(x => x.id === entityId);
    setCurrentOrgFormId(entityRow.orgFormId);
    setCurrentConsignorId(entityRow.consignorId || null);
    setShowEditEntityDocs(true);
  };

  const handleEditLegalEntityTaxs = entityId => {
    setCurrentEntityId(entityId);
    setCurrentOrgFormId(entitiesData.find(x => x.id === entityId).orgFormId);
    setCurrentEntityName(entitiesData.find(x => x.id === entityId).name);
    setShowEditEntityTaxs(true);
  };

  const handleEditLegalEntityGosLog = entityId => {
    setCurrentEntityId(entityId);
    setCurrentOrgFormId(entitiesData.find(x => x.id === entityId).orgFormId);
    setCurrentEntityName(entitiesData.find(x => x.id === entityId).name);
    setShowEditEntityGosLog(true);
  };

  if (errorMsg) {
    return <div className="content-error-block">{errorMsg}</div>;
  }

  const columns = [
    {
      title: i18n.t('companyPage.legalEntities.table.name.title'),
      dataIndex: "name",
      width: "30%",
      ...tableHelper.getColumnSearchProps("name", searchText, setSearchText),
    },
    {
      title: i18n.t('companyPage.legalEntities.table.orgForm.title'),
      dataIndex: "orgForm",
      width: "10%",
    },
    {
      title: i18n.t('companyPage.legalEntities.table.confirmation.title'),
      dataIndex: "confirmation",
      width: "15%",
    },
    {
      title: i18n.t('companyPage.legalEntities.table.tax.title'),
      dataIndex: "tax",
      width: "10%",
    },
    {
      title: "",
      key: "ship-companies",
      width: "20%",
      render: (data) => {
        return (
          <React.Fragment>
            {/*<Button*/}
            {/*  type="primary"*/}
            {/*  htmlType="button"*/}
            {/*  style={{*/}
            {/*    width: "170px",*/}
            {/*    height: "50px",*/}
            {/*    background: "#1CAA53",*/}
            {/*    position: "static",*/}
            {/*    borderRadius: "10px",*/}
            {/*    color: "white",*/}
            {/*    borderColor: "transparent",*/}
            {/*  }}*/}
            {/*  size="small"*/}
            {/*  className="small-button typical-btn-green"*/}
            {/*  onClick={() => {*/}
            {/*    setCurrentEntityId(data.id);*/}
            {/*    setShowModalShipCompanies(true);*/}
            {/*  }}*/}
            {/*>*/}
            {/*  {!data.permissions.IsLegalEntityEditable*/}
            {/*    ? i18n.t('companyPage.legalEntities.buttons.addContract')*/}
            {/*    : i18n.t('companyPage.legalEntities.buttons.agreement')}*/}
            {/*</Button>*/}
          </React.Fragment>
        );
      },
    },
    {
      title: "",
      key: "actions",
      width: "30%",
      render: (data) => {
        if (data.permissions.IsLegalEntityEditable) {
          return (
            <React.Fragment>
              <Button title={i18n.t('main.buttons.edit')} type="primary" icon="edit" htmlType="button" size="small" className="small-button typical-btn-green" onClick={() => handleEditLegalEntity(data.id)} />
              <Button title={i18n.t('main.buttons.editDocs')} type="primary" icon="file-word" htmlType="button" size="small" className="small-button typical-btn-green" onClick={() => handleEditLegalEntityDocs(data.id)} />
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment>
              {(data.permissions.IsLegalEntityCanChangeTax && data.countryId === 1) && <Button title={i18n.t('companyPage.legalEntities.buttons.tax.title')} type="primary" htmlType="button" size="small" className="small-button typical-btn-green" onClick={() => handleEditLegalEntityTaxs(data.id)}>{i18n.t('companyPage.legalEntities.buttons.tax.name')}</Button>}
              {(data.permissions.IsLegalEntityCanChangeGosLog && data.countryId === 1) && <Button title={i18n.t('Г.Л')} type="primary" htmlType="button" size="small" className="small-button typical-btn-green" onClick={() => handleEditLegalEntityGosLog(data.id)}>{i18n.t('Г.Л')}</Button>}
            </React.Fragment>
          );
        } 
      },
    },
    {
      title: "",
      key: "delete",
      width: "10%",
      render: (data) => {
        if (data.permissions.IsLegalEntityDeletable) {
          return (
            <React.Fragment>
              <Button title={i18n.t('main.buttons.delete')} type="primary" icon="delete" htmlType="button" size="small" className="small-button typical-btn-red" onClick={() => handleDeleteLegalEntity(data.id)} />
            </React.Fragment>
          );
        } else {
          return null;
        }
      },
    },
  ];


  if (!user.isAccessTo(CONSIGNOR_DIRECTOR_PERMISSION)) {
    return <Redirect to="/company/car-park" />;
  }

  return (
    <React.Fragment>
      <NotificationMessage
        notifications={notifications}
        setStopListUpdate={setStopListUpdate}
        loading={false}
      />

      <Row>
        <Col
          className={"content-header"}
          style={{ marginBottom: "0px" }}
          span={12}
        >
          {i18n.t('companyPage.legalEntities.title')}
        </Col>
        <Col span={8} style={{ marginBottom: "0px" }} offset={4}>
          <Button
            type="primary"
            htmlType="button"
            onClick={() => {
           //   setShowModalCreateEntityTest(true);
                setShowAgreementModal(true);
            }}
            style={bigButtonStyle}
          >
            {i18n.t('companyPage.legalEntities.buttons.addLegalEntity')}
          </Button>
            <ModalLegalEntityAgreement
                isShow={showAgreementModal}
                setIsShow={setShowAgreementModal}
                onAccepted={() => {
                    setIsAgree(1);
                    setShowAgreementModal(false);
                    setShowModalCreateEntityTest(true);
                }}
            />
          <ModalCreateNewLegalEntity
            isShow={showModalCreateEntityTest}
            setIsShow={setShowModalCreateEntityTest}
            setLoadingList={setIsNeedUpdateEntities}
            setStopListUpdate={setStopListUpdate}
            isAgree={isAgree}
          />
        </Col>
      </Row>

      <Col span={24}>
        <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
          <Table
            style={{ minWidth: "700px" }}
            columns={columns}
            dataSource={entitiesData}
            locale={{ emptyText: i18n.t('main.empty') }}
            rowKey="id"
            size="small"
            pagination={{
              pageSize: 50,
            }}
            className="car-park"
            rowClassName={(record, index) => "car-park-row"}
          />
        </Spinner>
      </Col>
      <ModalListShipCompanies
        isShow={showModalShipCompanies}
        setIsShow={setShowModalShipCompanies}
        legalEntityId={currentEntityId}
      />

      <ModalEditLegalEntityNew
        isShow={isShowEditEntity}
        setIsShow={setShowEditEntity}
        legalEntityId={currentEntityId}
        setLoadingList={setLoading}
        setStopListUpdate={setStopListUpdate}
      />
      <ModalEditLegalEntityDocs
        isShow={isShowEditEntityDocs}
        setIsShow={setShowEditEntityDocs}
        legalEntityId={currentEntityId}
        orgForm={currentOrgFormName}
        consignorId={currentConsignorId}
      />
       <ModalEditLegalEntityTax
         isShow={isShowEditEntityTaxs}
         setIsShow={setShowEditEntityTaxs}
         legalEntityId={currentEntityId}
         legalEntityName={currentEntityName}
         setIsNeedUpdate={setIsNeedUpdateEntities}
       />
       <ModalEditLegalEntityGosLog
         isShow={isShowEditEntityGosLog}
         setIsShow={setShowEditEntityGosLog}
         legalEntityId={currentEntityId}
         legalEntityName={currentEntityName}
         setIsNeedUpdate={setIsNeedUpdateEntities}
       />
    </React.Fragment>
  );
}
